import Page from '../../layout/Page'
import PatientSelectPageContent from './PatientSelectPageContent'
import PatientSelectPageMenu from './PatientSelectPageMenu'
import AuthenticationService from '../../services/AuthenticationService'

const PatientSelectPage = () => {
  const isPractitioner = AuthenticationService.isPractitioner()
  
  return (
    <Page 
      content={<PatientSelectPageContent />} 
      menu={isPractitioner ? <PatientSelectPageMenu /> : undefined}
    />
  )
}

export default PatientSelectPage
